import { render, staticRenderFns } from "./DocumentManagement.vue?vue&type=template&id=051009ae&scoped=true"
import script from "./DocumentManagement.vue?vue&type=script&lang=js"
export * from "./DocumentManagement.vue?vue&type=script&lang=js"
import style0 from "./DocumentManagement.vue?vue&type=style&index=0&id=051009ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051009ae",
  null
  
)

export default component.exports